<template>
  <w-modal
    v-model="show"
    :title="title"
    :close-on-submit="false"
    :hideOnOverlay="false"
    :hideOnEsc="false"
    :showCloseButton="false"
    :showFooter="false"
    @submit="close()"
    @close="close()"
  >
    <div>
      <span class="mb-2 presence-title text-uppercase">{{ $t('text.calendar.descriptionLabel') }}</span>

      <p style="padding: 0.4em 0.8em;">{{ description }}</p>

      <check-permission permissions="SCHEDULES_CONTAINER.UPDATE">
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" @click="excludeEvent()">
            {{ $t('buttons.excludeEvent') }}
          </button>

          <button type="button" class="btn btn btn-primary" @click="endSchedule()">
            {{ $t('buttons.endSchedule') }}
          </button>
        </div>
      </check-permission>
    </div>
  </w-modal>
</template>

<script>
import moment from 'moment';

import { DateFormat } from '@/enums/dateFormat.enum';
import { ScheduleFrequency } from '@/enums/scheduleFrequency.enum';
import { ScheduleType } from '@/enums/scheduleType.enum';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/scheduleContainer.schema';
import { formatTitle } from '@/utils/calendar';
import { tryParseInt } from '@/utils/number';

const emptyData = () => ({
  name: '',
  description: '',
  start: '',
  end: '',
  entityId: '',
  entityType: '',
  schedules: []
});

// @vuese
// Modal wydarzenia
// @group Components
export default {
  name: 'EventModal',
  mixins: [manageMixin('schedule', {}, emptyData)],
  schema,
  props: {
    // Wydarzenie
    event: {
      type: Object,
      required: false
    }
  },
  computed: {
    title() {
      if (this.event) {
        return formatTitle(this.event.eventDate, this.event.eventHour, this.event.eventMinute, this.event.eventTitle);
      } else {
        return '';
      }
    },
    description() {
      return this.$schema.description.$value ? this.$schema.description.$value : this.$t('text.calendar.description');
    }
  },
  methods: {
    // @vuese
    // Tworzy harmonogram składowy jednodniowy wykluczający
    excludeEvent() {
      this.$schema.schedules.$model.push({
        name: this.$t('text.calendar.excludeEvent'),
        description: '',
        start: moment(this.event.eventDate).format(DateFormat.DATE),
        end: moment(this.event.eventDate).format(DateFormat.DATE),
        type: ScheduleType.EXCLUDE,
        frequencyType: ScheduleFrequency.ONCE,
        frequency: 1,
        day: null,
        month: null,
        week: null,
        hour: null,
        minute: null,
        order: this.$schema.schedules.$model.length,
        duration: 1440
      });

      this.update();
      this.close();
    },

    // @vuese
    // Ustawia datę końca kontenera na datę wybranego wydarzenia
    endSchedule() {
      this.$schema.$setData({
        end: moment(this.event.eventDate).format(DateFormat.DATE)
      });

      this.update();
      this.close();
    },

    // @vuese
    // Aktualizuje kontener harmonogramów
    update() {
      if (!this.$schema.$validateAll().length) {
        this.$store
          .dispatch('schedule/update', {
            id: tryParseInt(this.id, 10),
            ...this.model
          })
          .then(() => {
            this.notifySuccess('messages.schedule.updated');
            this.$emit('updated');
          })
          .catch(err => {
            err.message
              ? this.notifyError('messages.schedule.updateError', [err.message])
              : this.notifyError('messages.schedule.updateError');
          });
      }
    }
  }
};
</script>

<style scoped>
.presence-title {
  padding: 0.4em 0.8em;
  font-size: 0.8rem;
  color: #27738d;
}
</style>
